<template>
  <div class="main-view">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" :model="searchForm">
        <el-form-item label="创建时间">
          <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
        </el-form-item>
        <el-form-item label="所属模块">
          <el-select clearable v-model="searchForm.moduleCode" class="selectWidth">
            <el-option label="交易" :value="1"></el-option>
            <el-option label="结算" :value="2"></el-option>
            <el-option label="打款" :value="3" v-if="!isInstitution"></el-option>
            <el-option label="分润" :value="4" v-if="isAgent"></el-option>
            <el-option label="上报查询" :value="5" v-if="!isInstitution"></el-option>
            <el-option label="码牌批量解绑" :value="6" v-if="isAgent"></el-option>
            <el-option label="机构" :value="7" v-if="isInstitution"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报表名称">
          <el-input class="selectWidth" v-model="searchForm.filename" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <auth-button
            opt="search"
            :plain="true"
            icon="el-icon-search"
            @click.native="search"
            :loading="loading"
            label="查询"></auth-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%;"
        align="center"
        v-loading="loading"
        :data="list"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          type="index"
          label="序号"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fFileName"
          label="报表名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fCreateTime"
          label="创建时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fModuleName"
          label="所属模块"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fDownloadRecord"
          width="100"
          label="下载量"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          :context="_self">
          <template slot-scope="scope">
            <span v-if="scope.row.fStatus === 2">{{ scope.row.fFailReason }} 请重新导出</span>
            <span v-if="scope.row.fStatus === 0">正在导出,请稍候</span>
            <auth-button
              opt="download"
              type="text"
              v-if="scope.row.fStatus === 1"
              label="下载"
              @click.native="handleDown(scope.row)"></auth-button>
            <auth-button
              opt="delete"
              type="text"
              v-if="scope.row.fStatus === 1"
              label="删除"
              @click.native="handleDelete(scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
    </el-col>
  </div>
</template>

<script>
import qs from 'qs'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { downloadRecord, downloadFile, removeDownload } from '@/api/setting'
export default {
  name: 'DownloadCenter',
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    return {
      loading: false,
      creatTime: [],
      searchForm: {
        startTime: '',
        endTime: '',
        moduleCode: '',
        filename: ''
      },
      list: [],
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      isAgent: false,
      isInstitution: false
    }
  },
  mounted () {
    this.getList()
    const roleId = this.$store.getters.roleId
    if (roleId === 1 || roleId === 3) {
      this.isAgent = true
    }
    if (roleId === 10) {
      this.isInstitution = true
    }
  },
  methods: {
    /**
         * @description 日期组件选中事件
         * @param  {String} value 当前结果
         */
    dateChange (value) {
      this.creatTime = value
    },
    /**
         * @description 点击查询
         */
    search () {
      this.paginations.pageNo = 1
      this.getList()
    },
    /**
         * @description 列表请求
         */
    getList () {
      this.searchForm.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchForm.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      const that = this
      that.loading = true
      const data = qs.stringify(Object.assign({}, this.searchForm, this.paginations))
      downloadRecord(data).then(response => {
        that.loading = false
        if (parseInt(response.result_cde) === 0) {
          that.paginations.count = response.totalCount
          that.list = response.list
        } else {
          that.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
         * @description 清除对象中无值属性
         */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
         * @description 改变当前页事件
         * @param  {Object} value 当前结果
         */
    onChangeCurrentPage (value) {
      this.paginations.pageNo = value
      this.getList()
    },
    /**
         * @description 下载选中报表
         * @param  {Object} row 当前行
         */
    handleDown (row) {
      const id = row.fId
      const data = qs.stringify({
        recordId: id
      })
      downloadFile(data).then((response) => {
        const blob = new Blob([response])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', row.fFileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    /**
         * @description 删除选中报表
         * @param  {Object} row 当前行
         */
    handleDelete (row) {
      const that = this
      this.$confirm('是否确认删除选中报表？', {
      }).then(() => {
        const id = row.fId
        const data = qs.stringify({
          recordId: id
        })
        removeDownload(data).then(response => {
          if (parseInt(response.result_cde) === 0) {
            that.$message({
              message: response.result_msg,
              type: 'success'
            })
            that.getList()
          } else {
            that.$message({
              message: response.result_msg,
              type: 'error'
            })
          }
        })
      })
    }
  }
}
</script>

<style scoped>
    .main-view{
        padding: 0 16px;
    }
    .selectWidth{
        width: 150px;
    }
    .btm-action {
        margin: 20px 0;
        text-align: center;
    }
</style>
